import { Environments, PartialServiceMap } from '@innovyze/stylovyze';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Info 360 Sensor Data Service
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

export const SERVICE_MAP_OVERRIDE: PartialServiceMap = {
  // getApiEnvironment returns DEV instead of LOCAL for some reason
  [Environments.LOCAL]: {
    sensorDataV2: 'http://localhost:3276/dev',
  },
};
